<div class="body">
  <form (submit)="addList()" [formGroup]="formGroup">
    <input type="text" class="form-control" formControlName="name"/>
    <br/>
    <textarea formControlName="list" class="form-control" rows="20"></textarea>
    <button type="submit" class="btn btn-primary">Lijst maken</button>
  </form>
</div>
